var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignprocess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.642,
    height: 71.126,
    viewBox: "0 0 71.642 71.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "design_process",
    "data-name": "design process",
    transform: "translate(-1394.781 -5315.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21926",
    "data-name": "Path 21926",
    d: "M30.26,10.995c3.413-26.869,30.26,1.884,30.26,18.6A30.26,30.26,0,0,1,0,29.591C0,12.878,26.847,37.863,30.26,10.995Z",
    transform: "matrix(0.978, -0.208, 0.208, 0.978, 1394.781, 5328.462)",
    fill: "#bcfbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "design_1_",
    "data-name": "design(1)",
    d: "M40.475,1.514A4.2,4.2,0,0,0,37.5,2.735L36.457,3.786a1.411,1.411,0,0,0-.121.116l-.524.524a1.41,1.41,0,0,0-.245.313L33.229,7.291l-.042.054-7.649,7.649L12.991,2.447a2.883,2.883,0,0,0-3.964,0L2.26,9.217a2.87,2.87,0,0,0,0,3.97l.006.006,12.665,12.4L7.146,33.379a1.41,1.41,0,0,0-1,.928L1.919,47.277A1.41,1.41,0,0,0,3.7,49.053l12.969-4.229a1.41,1.41,0,0,0,.716-.539L25.5,36.162,37.78,48.706l.006.006a2.87,2.87,0,0,0,3.97,0l6.767-6.767a2.865,2.865,0,0,0,0-3.967L36.1,25.561l8.066-8.066a1.41,1.41,0,0,0,.321-.5l1.74-1.6.006-.006a1.41,1.41,0,0,0,.31-.234l.522-.524A1.41,1.41,0,0,0,47.2,14.5l1.035-1.035a4.229,4.229,0,0,0,0-5.943l-4.793-4.79a4.187,4.187,0,0,0-2.966-1.221Zm0,2.741a1.408,1.408,0,0,1,.978.474l4.793,4.793a1.248,1.248,0,0,1,0,1.954l-1.063,1.069-.017.017-.068.059-1.988,1.819L36.534,7.863l1.878-2.055L39.5,4.728a1.4,1.4,0,0,1,.976-.474Zm-29.463.2L23.544,16.987,16.93,23.6l-2.064-2.03,4.821-4.821L16.9,13.959l-4.852,4.855-2.9-2.848L11.1,14.013,8.305,11.227,6.323,13.209,4.268,11.2l6.744-6.744ZM34.278,10.24,36.04,12,11.446,36.6,9.684,34.834ZM38.831,14.8l2.027,2.024L16.265,41.415l-2.027-2.027Zm-4.72,12.758L46.517,39.96l-6.744,6.747-1.779-1.813,4.756-4.756-2.791-2.791-4.725,4.728-3.039-3.1,1.968-1.965-2.791-2.791-1.934,1.931L27.5,34.169l6.614-6.614Zm-26,9.812,5.489,5.492L6.388,45.21l-.626-.629,2.351-7.215Z",
    transform: "translate(1409.303 5326.918)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignprocess);
export default __webpack_public_path__ + "static/media/designprocess.cdecb3ef0ce4f1244e36f5677f5aec43.svg";
export { ForwardRef as ReactComponent };